import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';

import { DynamicFilterOptions } from '../report-groups-dynamic-filter.types';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'aos-checkbox-dynamic-filter',
  imports: [ReactiveFormsModule, KENDO_INPUTS, TranslateModule],
  template: `
    <form
      class="aos-dynamic-filters"
      [formGroup]="form()"
    >
      <div class="aos-dynamic-filters__radiobuttons-container">
        @for (filter of $any(form().get('values')).controls; track filter; let index = $index) {
          <label
            class="aos-dynamic-filters__label"
            [formGroup]="filter"
          >
            @let formControlName = items()[index];
            @let formControl = filter.get(formControlName);
            @let displayFormControlName = displayFormControlNames()[index];
            <input
              [value]="formControl.value"
              [formControl]="formControl"
              kendoCheckBox
              type="checkbox"
            />
            <span>
              {{ displayFormControlName | translate }}
            </span>
          </label>

          @if ((index + 1) % 3 === 0) {
            <div class="aos-dynamic-filters__break"></div>
          }
        }
      </div>
    </form>
  `,
  styleUrl: './dynamic-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxDynamicFilterComponent {
  form = input.required<FormGroup>();
  items = input.required<DynamicFilterOptions[]>();

  displayFormControlNames = computed(() =>
    this.items().map(item => (item === 'BaseStation' ? 'SBS' : translationKeysMap.get(item) || item))
  );
}
